import React from "react";
import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import type { ScheduledReportUserWithoutRow } from "@/app2/shared/data";
import { PAGE_SIZE, type SortOrder } from "./utils";

export interface ScheduledReportsUsersWithoutTableProps {
  count: number;
  rows: ScheduledReportUserWithoutRow[];
  totalCount: number;
  sort: { column: string | null; order: SortOrder };
  onSort: (column: string) => void;
  page: number;
  onPageChange: (page: number) => void;
}

export const ScheduledReportsUsersWithoutTable: React.FC<ScheduledReportsUsersWithoutTableProps> = ({
  count,
  rows,
  totalCount,
  sort,
  onSort,
  page,
  onPageChange,
}) => (
  <Stack spacing={2} sx={{ width: "100%" }}>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, color: "rgba(255,255,255,0.7)" }}>
      Users Without Lesson Completions ({count})
    </Typography>
    <TableContainer component={Paper}>
      <Table
        size="small"
        sx={{
          "& .MuiTableCell-root": {
            borderColor: "rgba(255,255,255,0.1)",
            py: 2,
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={sort.column === "Name"}
                direction={sort.column === "Name" ? sort.order : "asc"}
                onClick={() => onSort("Name")}
              >
                <strong>Name</strong>
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={sort.column === "Division"}
                direction={sort.column === "Division" ? sort.order : "asc"}
                onClick={() => onSort("Division")}
              >
                <strong>Division</strong>
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={sort.column === "Supervisor"}
                direction={sort.column === "Supervisor" ? sort.order : "asc"}
                onClick={() => onSort("Supervisor")}
              >
                <strong>Supervisor</strong>
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={sort.column === "Date of Last Completion"}
                direction={sort.column === "Date of Last Completion" ? sort.order : "asc"}
                onClick={() => onSort("Date of Last Completion")}
              >
                <strong>Last Completion Date</strong>
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
                  {rows.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{String(row.Name ?? "")}</TableCell>
                      <TableCell>{String(row.Division ?? "")}</TableCell>
                      <TableCell>{String(row.Supervisor ?? "")}</TableCell>
                      <TableCell>
                        {row["Date of Last Completion"]
                          ? dayjs(String(row["Date of Last Completion"])).format("YYYY-MM-DD")
                          : "Never"}
                      </TableCell>
                    </TableRow>
                  ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalCount}
        page={page - 1}
        onPageChange={(_, p) => onPageChange(p + 1)}
        rowsPerPage={PAGE_SIZE}
        rowsPerPageOptions={[]}
      />
    </TableContainer>
  </Stack>
);
